import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=6be29d87&scoped=true&"
import script from "./introduction.vue?vue&type=script&lang=js&"
export * from "./introduction.vue?vue&type=script&lang=js&"
import style1 from "./introduction.vue?vue&type=style&index=1&id=6be29d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be29d87",
  null
  
)

export default component.exports